/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpigreq33Inputs */

const en_crosspostinghelpigreq33 = /** @type {(inputs: Crosspostinghelpigreq33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Facebook first, then Instagram. When connecting, Meta asks for the Facebook Page first and the Instagram account second - this step cannot be skipped.`)
};

const de_crosspostinghelpigreq33 = /** @type {(inputs: Crosspostinghelpigreq33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde zuerst Facebook, dann Instagram. Beim Verbinden fragt Meta zuerst nach der Facebook-Seite und dann nach dem Instagram-Konto – dieser Schritt lässt sich nicht überspringen.`)
};

/**
* | output |
* | --- |
* | "Connect Facebook first, then Instagram. When connecting, Meta asks for the Facebook Page first and the Instagram account second - this step cannot be skipped." |
*
* @param {Crosspostinghelpigreq33Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpigreq33 = /** @type {((inputs?: Crosspostinghelpigreq33Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpigreq33Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpigreq33(inputs)
	return de_crosspostinghelpigreq33(inputs)
});
export { crosspostinghelpigreq33 as "crosspostingHelpIgReq3" }